import "./DateRangePicker.css";

/*
  DateRangePicker.jsx — Date range selection component

  Lets the user narrow the vessel track to a specific time window.
  Both dates are optional — leaving them blank shows all records.

  Sits between the vessel search and the map in the paid tier UI.
*/

export default function DateRangePicker({ startDate, endDate, onChange }) {
  function handleStartChange(e) {
    onChange({ startDate: e.target.value, endDate });
  }

  function handleEndChange(e) {
    onChange({ startDate, endDate: e.target.value });
  }

  function clearDates() {
    onChange({ startDate: "", endDate: "" });
  }

  return (
    <div className="date-picker">
      <h3 className="date-picker-title">Filter by date range <span className="date-picker-optional">(optional)</span></h3>
      <div className="date-picker-row">
        <div className="date-picker-field">
          <label className="date-picker-label">From</label>
          <input
            type="datetime-local"
            className="date-picker-input"
            value={startDate}
            onChange={handleStartChange}
          />
        </div>
        <div className="date-picker-field">
          <label className="date-picker-label">To</label>
          <input
            type="datetime-local"
            className="date-picker-input"
            value={endDate}
            onChange={handleEndChange}
          />
        </div>
        {(startDate || endDate) && (
          <button className="date-picker-clear" onClick={clearDates}>
            Clear
          </button>
        )}
      </div>
    </div>
  );
}
